import { useTranslation } from 'react-i18next';
import styles from './firstIssueShortcut.module.css';

export interface IFirstIssueShortcutProps {
  onClick: () => void;
}

/** Dashed "add the first issue" card shown after a Daily List that has
 *  activities but no issues yet — the state-derived analog of trusstor's
 *  CreateNewIssueShortcut (which relied on the seeded initial issue). */
export function FirstIssueShortcut({ onClick }: IFirstIssueShortcutProps) {
  const { t } = useTranslation();
  return (
    <button type="button" className={styles.shortcut} onClick={onClick}>
      <span className={styles.plus} aria-hidden="true">
        ＋
      </span>
      {t('activities.firstIssueShortcut')}
    </button>
  );
}
